import { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  List,
  ListItem,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import request from "../../../utilities/requests";
import formatDate from "../../../utilities/formatDate";

const AckLog = ({ messageId }) => {
  const [log, setLog] = useState([]);

  useEffect(() => {
    if (messageId) {
      getLog();
    }
  }, [messageId]);

  const getLog = async () => {
    const result = await request(
      `systemmessage/acklog/?messageId=${messageId}`
    );
    if (result.success) {
      setLog(result.log);
    }
  };

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Acknowledgment Log ({log.length})</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <List>
          {log.map((entry, index) => (
            <ListItem
              key={index}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Typography>
                {entry.email} ({entry.org})
              </Typography>
              <Typography variant="caption">
                {formatDate(entry.acknowledgedAt)}
              </Typography>
            </ListItem>
          ))}
        </List>
      </AccordionDetails>
    </Accordion>
  );
};

export default AckLog;
